import { useSelector } from "react-redux";
import DashboardCard from "shared/DashboardCard";
import DonationSearchBar from "shared/DonationSearchBar";

const Details = ({ setDonationCurrent }) => {
  const { donations } = useSelector((state) => state.donation);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4 max-[670px]:flex-wrap">
        <DashboardCard
          className="rounded-lg"
          title="Total Donations"
          completedProjects={donations?.length}
          paragraph="since January"
          textColor="text-white"
          paragraphColor="text-[#F0CA18]"
          bgColor="bg-[#011F56]"
          percentage="+0%"
        />
        <DashboardCard
          className="rounded-lg !bg-[#fafafafa]"
          title="Cash Donations"
          completedProjects={
            donations?.filter((donation) => donation.type === "money").length
          }
          paragraph="since January"
          paragraphColor="#0ABD06"
          bgColor="bg-white"
          percentage="0"
        />
        <DashboardCard
          className="rounded-lg !bg-[#fafafafa]"
          title="Item Donations"
          completedProjects={
            donations?.filter((donation) => donation.type === "item").length
          }
          paragraph="since January"
          paragraphColor="#0ABD06"
          bgColor="bg-white"
          percentage="0%"
        />
      </div>
      <DonationSearchBar
        setDonationCurrent={setDonationCurrent}
        searchText="Search Donations"
        param="Donations"
      />
    </div>
  );
};

export default Details;
